import { FC, MouseEvent } from 'react';
import toast from 'react-hot-toast';
import { useCopyToClipboard } from 'usehooks-ts';
import { CopyIcon } from 'shared/ui';
import { Link } from 'shared/ui/link';
import { IdCellStyled } from './id-cell.styled';
import { IIdCellProps } from './id-cell.types';

export const IdCell: FC<IIdCellProps> = ({ streamId }) => {
  const [, copy] = useCopyToClipboard();

  const copyClickHandler = async (e: MouseEvent) => {
    e.stopPropagation();

    await copy(streamId);
    toast('Copied to clipboard!');
  };

  return (
    <IdCellStyled>
      <Link to="#">{streamId}</Link>
      <CopyIcon onClick={copyClickHandler} className="copy-icon" />
    </IdCellStyled>
  );
};
